import { useEffect, useRef, useState } from 'react';
import { telemedicineApi, RealtimeEvent } from '@/api/telemedicine-api';

interface UseRealtimeEventsOptions {
  sessionId?: string;
  pollInterval?: number;
}

export function useRealtimeEvents({ sessionId, pollInterval = 2000 }: UseRealtimeEventsOptions = {}) {
  const [events, setEvents] = useState<RealtimeEvent[]>([]);
  const [latestTimestamp, setLatestTimestamp] = useState<string | null>(null);
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (!sessionId) {
      setEvents([]);
      return;
    }

    const poll = async () => {
      try {
        const { events: newEvents } = await telemedicineApi.pollRealtimeEvents(sessionId, latestTimestamp || undefined);
        if (newEvents.length > 0) {
          setEvents(prev => [...prev, ...newEvents]);
          setLatestTimestamp(newEvents[newEvents.length - 1]!.timestamp);
        }
      } catch (err) {
        console.error('[useRealtimeEvents] poll failed', err);
      }
    };

    poll();
    intervalRef.current = window.setInterval(poll, pollInterval);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [sessionId, pollInterval, latestTimestamp]);

  return { events, latestTimestamp };
}